<template>
  <div>
      <Label :required="type == 'select' && required || type == 'radio' || type === undefined" :label="label" :for_id="'civilite'"/>
      <div v-if="type === undefined || type === 'radio'" class="form_item boxes">
        <input
          id="madame"
          value="madame"
          :name="validationLabel || label"
          key="civilite0"
          type="radio"
          v-model="val"
          v-validate="'required'"
          required
        />
        <label for="madame">{{LabelMadame}}</label>

        <input
          id="monsieur"
          value="monsieur"
          :name="validationLabel || label"
          key="civilite1"
          type="radio"
          v-model="val"
          v-validate="'required'"
          required
        />
        <label for="monsieur">{{LabelMonsieur}}</label>
        <p v-if="info !== undefined" class="info" v-html="info"></p>
      </div>
      <Select v-else
        :options="options"
        :label="label"
        :displayLabel="false"
        id="civilite"
        :info="info"
        :required="required"
        v-model="val"/>
  </div>
</template>

<script>
import { validatorComponent } from './validatorComponentMixin';
import Select from './Select';
import i18n from './i18n';


export default {
  name: 'Civilite',
  components: {
    Select
  },
  data: function () {
    return {
      options: [
        { name: this.LabelMadame, value: 'madame' },
        { name: this.LabelMonsieur, value: 'monsieur' }
      ]
    };
  },
  props: {
    type: String,
    save_to: String,
    validationLabel: String,
    locale: String,
    required: Boolean,
    LabelMadame: String,
    LabelMonsieur: String,
  },
  mixins: [validatorComponent, i18n.mixin]
};
</script>
